import React, { useState } from 'react';
import './CustomDialog.css'; // Custom styles for the dialog

const CustomDialog = ({ isOpen, onClose, onSubmitEmail, email, changeEmail, whatsapp_no, changeWhatsapp, expired_time, activeForm,setActiveForm,changeExpiredTime, handleKeyDown }) => {
  // Single state for controlling the active image and form
  // const [activeForm, setActiveForm] = useState(''); // '' means none, 'email' or 'whatsapp' for toggling

  // Conditional rendering based on isOpen
  if (!isOpen) return null;

  const onClickEmail = () => {
    setActiveForm(prev => prev === 'email' ? '' : 'email'); // Toggle email form
  };

  const onClickWhatsapp = () => {
    setActiveForm(prev => prev === 'whatsapp' ? '' : 'whatsapp'); // Toggle WhatsApp form
  };

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2 style={{ fontSize: "20px", color: "#fff", margin: "0px" }}>Share Tracking Link</h2>
        </div>
        <div className="dialog-body">
          <form onKeyDown={handleKeyDown}>
            <div className='row justify-content-center'>
              <img
                src={require("../../assets/images/mail_img1.png")}
                alt="Email"
                className={activeForm === 'email' ? 'active' : 'inactive'}
                onClick={onClickEmail}
              />
              <img
                src={require("../../assets/images/whtsapp_img.png")}
                alt="WhatsApp"
                className={activeForm === 'whatsapp' ? 'active' : 'inactive'}
                onClick={onClickWhatsapp}
              />
            </div>

            {activeForm === 'email' && (
              <>
                <label htmlFor="emailid">Enter Email ID</label>
                <input
                  type="email"
                  id="emailid"
                  name="emailid"
                  value={email}
                  onChange={changeEmail}
                  required
                  className="input-field"
                />
              </>
            )}
            {activeForm === 'whatsapp' && (
              <>
                <label htmlFor="whatsappid" className='mt-10p'>Enter WhatsApp Number</label>
                <input
                  type="text"
                  id="whatsappid"
                  name="whatsappid"
                  value={whatsapp_no}
                  onChange={changeWhatsapp}
                  required
                  className="input-field"
                />
                {/* <label htmlFor="expiredTime" className='mt-10p'>Expired Days</label>
                <input
                  type="text"
                  id="expiredTime"
                  name="expiredTime"
                  value={expired_time.label}
                  onChange={changeExpiredTime}
                  required
                  className="input-field"
                /> */}
              </>
            )}
          </form>
        </div>
        <div className="dialog-actions row">
          <div className='col-sm-12' style={{ display: "flex" }}>
            <div className='col-sm-6'>
              <button className="btn-primary mr-10p" style={{ padding: "10px 40px", fontSize: "14px" }} disabled={activeForm === ""? true: false} onClick={onSubmitEmail}>
                Send
              </button>
            </div>
            <div className='col-sm-6'>
              <button className="btn-secondary" style={{ padding: "10px 40px", margin: "0px", fontSize: "14px" }} onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomDialog;